// SweetAlert accepted 'warning'; PrimeVue names that severity 'warn'.
const SEVERITIES = {
    warning: 'warn',
}

export default {
    methods: {
        /**
         * Show a transient notification.
         *
         * @param {string} title
         * @param {string} type success | info | warn | error
         * @param {number} timer how long it stays up, in milliseconds
         */
        toast(title, type = 'success', timer = 4000) {
            this.$toast.add({
                severity: SEVERITIES[type] ?? type,
                summary: title,
                life: timer,
            })
        },
    },
}
